// material-ui
import { ThemeProvider, useTheme } from '@mui/material/styles';
import { Box, Drawer, IconButton, Typography, useMediaQuery } from '@mui/material';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';
import { BrowserView, MobileView } from 'react-device-detect';

// types
import PropTypes from 'prop-types';

// project imports
import MenuList from './MenuList';
import MenuCard from './MenuCard';
import { drawerWidth } from '../../../store/constant';
import { ContextUserInfo } from '../../MainLayout/index';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import customtheme from '../../../themes';
import defaultTheme from '../../../themes/defaultTheme';

// ==============================|| SIDEBAR DRAWER ||============================== //

const Sidebar = ({ drawerOpen, drawerToggle, window }) => {
    const theme = useTheme();
    const { userInfo, userPermissions, userRoles,menues } = useContext(ContextUserInfo);
    const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));
    const customization = useSelector((state) => state.customization);

    const drawer = (
        <>

<ThemeProvider theme={customtheme(customization)}>
    <Box sx={ {bgcolor: '#F1F1E8'}}>
            <Box sx={{ display: { xs: 'block', md: 'none' } }}>
                <Box sx={{ textAlign: 'right' ,display: 'flex', p: 2, mx: 'auto' }}>
                <Box
                sx={{ display: 'flex' }}
              >
                
                <Box sx={{ flexShrink: 0 }}>  </Box>

              </Box>
                </Box>
            </Box>
            <BrowserView>
                <PerfectScrollbar
                    component="div"
                    style={{
                        height: !matchUpMd ? 'calc(100vh - 56px)' : 'calc(100vh - 88px)',
                        paddingLeft: '16px',
                        paddingRight: '16px'
                    }}
                >
                    <MenuList menues={menues}/>
                    {/* <MenuCard /> */}
                </PerfectScrollbar>
            </BrowserView>
            <MobileView>
                <Box sx={{ px: 2 }}>
                    <MenuList menues={menues}/>
                    {/* <MenuCard /> */}
                </Box>
            </MobileView>
            </Box>
            </ThemeProvider>
        </>
    );

    const container = window !== undefined ? () => window.document.body : undefined;

    return (
       
        <Box component="nav" sx={{ flexShrink: { md: 0 }, width: matchUpMd ? drawerWidth : 'auto' }} aria-label="menu">
            <Drawer
                container={container}
                variant={matchUpMd ? 'persistent' : 'temporary'}
                anchor="right"
                open={drawerOpen}
                onClose={drawerToggle}
                sx={{
                  
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        background: theme.palette.background.default,
                        color: theme.palette.text.primary,
                        borderRight: 'none',
                        [theme.breakpoints.up('md')]: {
                            top: '88px'
                        }
                    }
                }}
                ModalProps={{ keepMounted: true }}
                color="inherit"
            >
                {drawer}
            </Drawer>
        </Box>
       
    );
};

Sidebar.propTypes = {
    drawerOpen: PropTypes.bool,
    drawerToggle: PropTypes.func,
    window: PropTypes.object
};

export default Sidebar;
